import { CourseTechnology } from "../../lib/prismic/mapData"
import { MappedCourse } from "../../lib/prismic/MappedCourse"

export const generateSeoDescription = (pageTitle: string, lecturer: string, slug: string, technology?: CourseTechnology): string => {
  const defaultTechnology = "moderní technologie"
  const technologyName = technology ? technology.name : defaultTechnology

  const templates = [
    `Online kurz pro děti a mládež: Objevte základy ${technologyName} s naším lektorem ${lecturer}. Naučte se programování a vytvořte vlastní projekty od základů v kurzu ${pageTitle}.`,
    `Začněte svou cestu k inovacím s online kurzem ${technologyName} pro děti a mládež, vedeným ${lecturer}. Získejte dovednosti pro budoucnost v kurzu ${pageTitle}.`,
    `Online kurz ${pageTitle} pro děti a mládež: Kreativní programování s ${technologyName}, které vás připraví na budoucnost. Lektor ${lecturer} vás provede základy a inovativními projekty.`,
    `Naučte se ${technologyName} s naším lektorem ${lecturer} v online kurzu ${pageTitle}. Kreativní a zábavné lekce, které vás uvedou do světa technologií a inovací.`,
    `Objevte základy ${technologyName} s naším online kurzem ${pageTitle} pro děti a mládež. Kreativita a inovace na dosah ruky s praktickými projekty a lekcemi od ${lecturer}.`
  ]

  const randomIndex = slug.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0) % templates.length
  const selectedTemplate = templates[randomIndex]

  if (selectedTemplate.length < 110) {
    return `${selectedTemplate} Zjistěte více o ${technologyName} s naším kurzem ${pageTitle}.`
  } else if (selectedTemplate.length > 160) {
    return selectedTemplate.slice(0, 157) + "..."
  }

  return selectedTemplate
}

export const adjustTitleLength = (course: MappedCourse): string => {
  const suffix = ""
  const maxLength = 60 - suffix.length
  const minLength = 50 - suffix.length

  let cleanName = course.name
    .replace(/(\s*\(\d{2}\s*-\s*\d{2}\s*let\))|(\s*–\s*[a-zA-Z0-9ěščřžýáíéúůů]+\s*[a-zA-Z0-9ěščřžýáíéúůů]+)/g, "")
    .replace(/\s*-\s*ukázková hodina/g, "")

  if (cleanName.length > maxLength) {
    const trimmedName = cleanName.slice(0, maxLength)
    const lastSpaceIndex = trimmedName.lastIndexOf(" ")
    cleanName = lastSpaceIndex > 0 ? trimmedName.slice(0, lastSpaceIndex) : trimmedName
  }

  if (cleanName.length < minLength) {
    cleanName = cleanName.padEnd(minLength)
  }

  return cleanName + suffix
}
